export default __webpack_public_path__ + "styles/plone-sphinx-theme.css";